<template>
  <v-card
    class="rounded-lg"
    elevation="3"
    max-width="300"
  >
    <v-card-title class="text-center">
      Welcome to Cash Blocks!
    </v-card-title>

    <v-card-text>
      To start do the following:

      <v-row
        v-for="(instruction, index) in instructions"
        :key="index"
        class="mx-0 mt-2 align-center"
      >
        <v-icon left v-text="instruction.icon" />
        {{ instruction.text }}
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    name: 'InstructionsCard',
    computed: {
      instructions () {
        return [
          { text: 'Right click to open the menu', icon: 'mdi-mouse' },
          { text: 'Select the block you want to use', icon: 'mdi-shape-square-plus' },
          { text: 'Right click on a block to edit it ', icon: 'mdi-square-edit-outline' },
          { text: 'Connect some blocks', icon: 'mdi-transit-connection-variant' },
        ]
      }
    },
  }
</script>

<style scoped>

</style>
